export const btnDescriptionEnum = {
  general: '請選擇尺寸',
  preShow: 'COMING SOON',
  addBag: '加入購物車',
  notice: '暫銷售一空 ♡ 感謝熱烈支持',
  soldOut: '已售完',
  addPre: '加入購物車 (預購)',
};

export const btnFoodDescriptionEnum = {
  general: '請選擇規格',
  preShow: 'COMING SOON',
  addBag: '加入購物車',
  notice: '暫銷售一空 ♡ 感謝熱烈支持',
  soldOut: '已售完',
  addPre: '加入購物車 (預購)',
};

export const btnStyleEnum = {
  disabled: 'disabled',
  activeMail: 'active-mail disabled',
  active: 'active',
};

export const addToCartEnum = {
  addSuccess: '加入購物車',
};
